import { render, staticRenderFns } from "./goodsList.vue?vue&type=template&id=657c0c42&"
import script from "./goodsList.vue?vue&type=script&lang=js&"
export * from "./goodsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('657c0c42')) {
      api.createRecord('657c0c42', component.options)
    } else {
      api.reload('657c0c42', component.options)
    }
    module.hot.accept("./goodsList.vue?vue&type=template&id=657c0c42&", function () {
      api.rerender('657c0c42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/itemListComp/goodsList.vue"
export default component.exports